import baseV3Service from './base/baseV3Service.js';

const getCommunities = (config) => {
    return baseV3Service.get("communities", config);
};
const getCommunity = (communityId, config) => {
    return baseV3Service.get(`communities/${communityId}`, config);
};
const updateCommunity = (communityId, payload, config) => {
    return baseV3Service.put(`communities/${communityId}`, payload, config);
};
const createCommunity = (payload, config) => {
    return baseV3Service.post("communities", payload, config);
};
const getCommunityPriceFields = (communityId, config) => {
    return baseV3Service.get(`communities/${communityId}/price-fields`, config);
};
const getCommunityAutoScanConfig = (communityId, config) => {
    return baseV3Service.get(`communities/${communityId}/auto-scan-fields`, config);
};
const createCommunityExternalId = (payload, config) => {
    return baseV3Service.post(`external-links`, payload, config);
};
const deleteCommunityExternalId = (externalId, config) => {
    return baseV3Service.delete(`external-links/${externalId}`, config);
};

export { createCommunity, createCommunityExternalId, deleteCommunityExternalId, getCommunities, getCommunity, getCommunityAutoScanConfig, getCommunityPriceFields, updateCommunity };
